/**
 * Generated by orval v8.13.0 🍺
 * Do not edit manually.
 * Api
 * Contractor Estimator API
 * OpenAPI spec version: 0.1.0
 */
import * as zod from 'zod';


/**
 * @summary Liveness probe — succeeds as soon as the HTTP server is listening
 */
export const HealthCheckResponse = zod.object({
  "status": zod.enum(['ok', 'degraded', 'starting']),
  "db": zod.enum(['ok', 'error'])
})


/**
 * @summary Readiness probe — succeeds once startup tasks have finished and the database is reachable
 */
export const ReadinessCheckResponse = zod.object({
  "status": zod.enum(['ok', 'degraded', 'starting']),
  "db": zod.enum(['ok', 'error'])
})


/**
 * @summary List all customers
 */
export const ListCustomersQueryParams = zod.object({
  "search": zod.coerce.string().optional()
})

export const ListCustomersResponseItem = zod.object({
  "id": zod.coerce.number(),
  "name": zod.string(),
  "email": zod.string().nullish(),
  "phone": zod.string().nullish(),
  "address": zod.string().nullish(),
  "addressLine1": zod.string().nullish(),
  "addressLine2": zod.string().nullish(),
  "city": zod.string().nullish(),
  "state": zod.string().nullish(),
  "postalCode": zod.string().nullish(),
  "country": zod.string().nullish(),
  "shippingAddressLine1": zod.string().nullish(),
  "shippingAddressLine2": zod.string().nullish(),
  "shippingCity": zod.string().nullish(),
  "shippingState": zod.string().nullish(),
  "shippingPostalCode": zod.string().nullish(),
  "shippingCountry": zod.string().nullish(),
  "paymentTermsDays": zod.coerce.number().nullish(),
  "notes": zod.string().nullish(),
  "taxExempt": zod.boolean().optional(),
  "stripeCustomerId": zod.string().nullish(),
  "stripeDefaultPaymentMethodId": zod.string().nullish(),
  "createdAt": zod.coerce.date()
})
export const ListCustomersResponse = zod.array(ListCustomersResponseItem)


/**
 * @summary Create a customer
 */
export const CreateCustomerBody = zod.object({
  "name": zod.string(),
  "email": zod.string().optional(),
  "phone": zod.string().optional(),
  "address": zod.string().optional(),
  "addressLine1": zod.string().nullish(),
  "addressLine2": zod.string().nullish(),
  "city": zod.string().nullish(),
  "state": zod.string().nullish(),
  "postalCode": zod.string().nullish(),
  "country": zod.string().nullish(),
  "shippingAddressLine1": zod.string().nullish(),
  "shippingAddressLine2": zod.string().nullish(),
  "shippingCity": zod.string().nullish(),
  "shippingState": zod.string().nullish(),
  "shippingPostalCode": zod.string().nullish(),
  "shippingCountry": zod.string().nullish(),
  "paymentTermsDays": zod.coerce.number().nullish(),
  "notes": zod.string().nullish(),
  "taxExempt": zod.boolean().optional()
})


/**
 * @summary Bulk delete customers by IDs
 */



export const BulkDeleteCustomersBody = zod.object({
  "ids": zod.array(zod.coerce.number()).min(1)
})

export const BulkDeleteCustomersResponse = zod.object({
  "deleted": zod.coerce.number()
})


/**
 * @summary Remove a customer's saved card
 */
export const DeleteCustomerSavedCardParams = zod.object({
  "id": zod.coerce.number()
})


/**
 * @summary Get a customer
 */
export const GetCustomerParams = zod.object({
  "id": zod.coerce.number()
})

export const GetCustomerResponse = zod.object({
  "id": zod.coerce.number(),
  "name": zod.string(),
  "email": zod.string().nullish(),
  "phone": zod.string().nullish(),
  "address": zod.string().nullish(),
  "addressLine1": zod.string().nullish(),
  "addressLine2": zod.string().nullish(),
  "city": zod.string().nullish(),
  "state": zod.string().nullish(),
  "postalCode": zod.string().nullish(),
  "country": zod.string().nullish(),
  "shippingAddressLine1": zod.string().nullish(),
  "shippingAddressLine2": zod.string().nullish(),
  "shippingCity": zod.string().nullish(),
  "shippingState": zod.string().nullish(),
  "shippingPostalCode": zod.string().nullish(),
  "shippingCountry": zod.string().nullish(),
  "paymentTermsDays": zod.coerce.number().nullish(),
  "notes": zod.string().nullish(),
  "taxExempt": zod.boolean().optional(),
  "stripeCustomerId": zod.string().nullish(),
  "stripeDefaultPaymentMethodId": zod.string().nullish(),
  "createdAt": zod.coerce.date()
})


/**
 * @summary Update a customer
 */
export const UpdateCustomerParams = zod.object({
  "id": zod.coerce.number()
})

export const UpdateCustomerBody = zod.object({
  "name": zod.string(),
  "email": zod.string().optional(),
  "phone": zod.string().optional(),
  "address": zod.string().optional(),
  "addressLine1": zod.string().nullish(),
  "addressLine2": zod.string().nullish(),
  "city": zod.string().nullish(),
  "state": zod.string().nullish(),
  "postalCode": zod.string().nullish(),
  "country": zod.string().nullish(),
  "shippingAddressLine1": zod.string().nullish(),
  "shippingAddressLine2": zod.string().nullish(),
  "shippingCity": zod.string().nullish(),
  "shippingState": zod.string().nullish(),
  "shippingPostalCode": zod.string().nullish(),
  "shippingCountry": zod.string().nullish(),
  "paymentTermsDays": zod.coerce.number().nullish(),
  "notes": zod.string().nullish(),
  "taxExempt": zod.boolean().optional()
})

export const UpdateCustomerResponse = zod.object({
  "id": zod.coerce.number(),
  "name": zod.string(),
  "email": zod.string().nullish(),
  "phone": zod.string().nullish(),
  "address": zod.string().nullish(),
  "addressLine1": zod.string().nullish(),
  "addressLine2": zod.string().nullish(),
  "city": zod.string().nullish(),
  "state": zod.string().nullish(),
  "postalCode": zod.string().nullish(),
  "country": zod.string().nullish(),
  "shippingAddressLine1": zod.string().nullish(),
  "shippingAddressLine2": zod.string().nullish(),
  "shippingCity": zod.string().nullish(),
  "shippingState": zod.string().nullish(),
  "shippingPostalCode": zod.string().nullish(),
  "shippingCountry": zod.string().nullish(),
  "paymentTermsDays": zod.coerce.number().nullish(),
  "notes": zod.string().nullish(),
  "taxExempt": zod.boolean().optional(),
  "stripeCustomerId": zod.string().nullish(),
  "stripeDefaultPaymentMethodId": zod.string().nullish(),
  "createdAt": zod.coerce.date()
})


/**
 * @summary Delete a customer
 */
export const DeleteCustomerParams = zod.object({
  "id": zod.coerce.number()
})


/**
 * @summary List all estimates
 */
export const ListEstimatesQueryParams = zod.object({
  "status": zod.enum(['draft', 'sent', 'accepted', 'declined', 'converted']).optional(),
  "customerId": zod.coerce.number().optional(),
  "search": zod.coerce.string().optional()
})

export const listEstimatesResponseTargetMarginMin = 0;
export const listEstimatesResponseTargetMarginMax = 90;



export const ListEstimatesResponseItem = zod.object({
  "id": zod.coerce.number(),
  "estimateNumber": zod.string().nullish(),
  "title": zod.string(),
  "status": zod.enum(['draft', 'sent', 'accepted', 'declined', 'converted']),
  "customerId": zod.coerce.number(),
  "customerName": zod.string().optional(),
  "customerPhone": zod.string().nullish(),
  "customerEmail": zod.string().nullish(),
  "total": zod.coerce.number(),
  "internalCost": zod.coerce.number().optional(),
  "profit": zod.coerce.number().optional(),
  "margin": zod.coerce.number().optional(),
  "targetMargin": zod.coerce.number().min(listEstimatesResponseTargetMarginMin).max(listEstimatesResponseTargetMarginMax).nullish().describe('This quote\'s target margin (%); null uses the target in Settings.'),
  "costBreakdown": zod.object({
  "labour": zod.coerce.number(),
  "materials": zod.coerce.number(),
  "fees": zod.coerce.number()
}).optional().describe('Internal cost totals grouped by parent category for the Internal Workshop popover.'),
  "description": zod.string().nullish(),
  "estimateDate": zod.string().nullish(),
  "validUntil": zod.string().nullish(),
  "depositType": zod.enum(['fixed', 'percent']).optional(),
  "depositValue": zod.coerce.number().optional(),
  "discountType": zod.enum(['fixed', 'percent']).nullish(),
  "discountValue": zod.coerce.number().nullish(),
  "discountAmount": zod.coerce.number().optional(),
  "taxEnabled": zod.boolean().optional(),
  "taxRate": zod.coerce.number().optional(),
  "selectedTaxLines": zod.string().nullish(),
  "linkedInvoiceId": zod.coerce.number().nullish(),
  "isRecurring": zod.boolean().optional(),
  "recurringInterval": zod.string().nullish(),
  "recurringCustomDays": zod.coerce.number().nullish(),
  "recurringStartDate": zod.string().nullish(),
  "recurringEndDate": zod.string().nullish(),
  "recurringNextDate": zod.string().nullish(),
  "recurringParentId": zod.coerce.number().nullish(),
  "createdAt": zod.coerce.date(),
  "updatedAt": zod.coerce.date()
})
export const ListEstimatesResponse = zod.array(ListEstimatesResponseItem)


/**
 * @summary Create an estimate
 */
export const CreateEstimateBody = zod.object({
  "estimateNumber": zod.string().nullish(),
  "title": zod.string().optional(),
  "customerId": zod.coerce.number(),
  "description": zod.string().optional(),
  "estimateDate": zod.string().nullish(),
  "validUntil": zod.string().nullish(),
  "depositType": zod.enum(['fixed', 'percent']).optional(),
  "depositValue": zod.coerce.number().optional(),
  "discountType": zod.enum(['fixed', 'percent']).nullish(),
  "discountValue": zod.coerce.number().nullish(),
  "taxEnabled": zod.boolean().optional(),
  "taxRate": zod.coerce.number().optional(),
  "selectedTaxLines": zod.string().nullish()
})


/**
 * @summary Get estimate with all details
 */
export const GetEstimateParams = zod.object({
  "id": zod.coerce.number()
})

export const getEstimateResponseTargetMarginMin = 0;
export const getEstimateResponseTargetMarginMax = 90;



export const GetEstimateResponse = zod.object({
  "id": zod.coerce.number(),
  "estimateNumber": zod.string().nullish(),
  "title": zod.string(),
  "status": zod.enum(['draft', 'sent', 'accepted', 'declined', 'converted']),
  "customerId": zod.coerce.number(),
  "customerName": zod.string().optional(),
  "customerPhone": zod.string().nullish(),
  "customerEmail": zod.string().nullish(),
  "customerAddressLine1": zod.string().nullish(),
  "customerAddressLine2": zod.string().nullish(),
  "customerCity": zod.string().nullish(),
  "customerState": zod.string().nullish(),
  "customerPostalCode": zod.string().nullish(),
  "customerCountry": zod.string().nullish(),
  "total": zod.coerce.number(),
  "internalCost": zod.coerce.number().optional(),
  "profit": zod.coerce.number().optional(),
  "margin": zod.coerce.number().optional(),
  "targetMargin": zod.coerce.number().min(getEstimateResponseTargetMarginMin).max(getEstimateResponseTargetMarginMax).nullish().describe('This quote\'s target margin (%); null uses the target in Settings.'),
  "description": zod.string().nullish(),
  "termsAndNotes": zod.string().nullish(),
  "estimateDate": zod.string().nullish(),
  "validUntil": zod.string().nullish(),
  "depositType": zod.enum(['fixed', 'percent']).optional(),
  "depositValue": zod.coerce.number().optional(),
  "discountType": zod.enum(['fixed', 'percent']).nullish(),
  "discountValue": zod.coerce.number().nullish(),
  "discountAmount": zod.coerce.number().optional(),
  "taxEnabled": zod.boolean().optional(),
  "taxRate": zod.coerce.number().optional(),
  "selectedTaxLines": zod.string().nullish(),
  "linkedInvoiceId": zod.coerce.number().nullish(),
  "isRecurring": zod.boolean().optional(),
  "recurringInterval": zod.string().nullish(),
  "recurringCustomDays": zod.coerce.number().nullish(),
  "recurringStartDate": zod.string().nullish(),
  "recurringEndDate": zod.string().nullish(),
  "recurringNextDate": zod.string().nullish(),
  "recurringParentId": zod.coerce.number().nullish(),
  "createdAt": zod.coerce.date(),
  "updatedAt": zod.coerce.date(),
  "lineItems": zod.array(zod.object({
  "id": zod.coerce.number(),
  "estimateId": zod.coerce.number(),
  "productId": zod.coerce.number().nullish(),
  "groupId": zod.coerce.number().nullish(),
  "description": zod.string(),
  "quantity": zod.coerce.number(),
  "unitPrice": zod.coerce.number(),
  "total": zod.coerce.number(),
  "sortOrder": zod.coerce.number().optional(),
  "privateNote": zod.string().nullish(),
  "internalCostTotal": zod.coerce.number().optional(),
  "productName": zod.string().nullish(),
  "materials": zod.array(zod.object({
  "id": zod.coerce.number(),
  "lineItemId": zod.coerce.number(),
  "catalogItemId": zod.coerce.number().nullish(),
  "name": zod.string(),
  "quantity": zod.coerce.number(),
  "unit": zod.string().nullish(),
  "unitCost": zod.coerce.number(),
  "totalCost": zod.coerce.number(),
  "supplier": zod.string().nullish(),
  "notes": zod.string().nullish(),
  "type": zod.enum(['labour', 'materials', 'fees']),
  "fromProductDefaultId": zod.coerce.number().nullish()
})).optional()
})),
  "groups": zod.array(zod.object({
  "id": zod.coerce.number(),
  "estimateId": zod.coerce.number(),
  "name": zod.string(),
  "sortOrder": zod.coerce.number(),
  "collapsedByDefault": zod.coerce.number(),
  "accentColor": zod.string().nullish()
}))
})


/**
 * @summary Update an estimate
 */
export const UpdateEstimateParams = zod.object({
  "id": zod.coerce.number()
})

export const updateEstimateBodyTargetMarginMin = 0;
export const updateEstimateBodyTargetMarginMax = 90;



export const UpdateEstimateBody = zod.object({
  "estimateNumber": zod.string().nullish(),
  "title": zod.string().optional(),
  "status": zod.enum(['draft', 'sent', 'accepted', 'declined', 'converted']).optional(),
  "customerId": zod.coerce.number().optional(),
  "description": zod.string().optional(),
  "estimateDate": zod.string().nullish(),
  "validUntil": zod.string().nullish(),
  "depositType": zod.enum(['fixed', 'percent']).optional(),
  "depositValue": zod.coerce.number().optional(),
  "discountType": zod.enum(['fixed', 'percent']).nullish(),
  "discountValue": zod.coerce.number().nullish(),
  "taxEnabled": zod.boolean().optional(),
  "taxRate": zod.coerce.number().optional(),
  "selectedTaxLines": zod.string().nullish(),
  "linkedInvoiceId": zod.coerce.number().nullish(),
  "isRecurring": zod.boolean().optional(),
  "recurringInterval": zod.string().nullish(),
  "recurringCustomDays": zod.coerce.number().nullish(),
  "recurringStartDate": zod.string().nullish(),
  "recurringEndDate": zod.string().nullish(),
  "targetMargin": zod.coerce.number().min(updateEstimateBodyTargetMarginMin).max(updateEstimateBodyTargetMarginMax).nullish().describe('This quote\'s target margin (%); null uses the target in Settings.'),
  "termsAndNotes": zod.string().nullish()
})

export const updateEstimateResponseTargetMarginMin = 0;
export const updateEstimateResponseTargetMarginMax = 90;



export const UpdateEstimateResponse = zod.object({
  "id": zod.coerce.number(),
  "estimateNumber": zod.string().nullish(),
  "title": zod.string(),
  "status": zod.enum(['draft', 'sent', 'accepted', 'declined', 'converted']),
  "customerId": zod.coerce.number(),
  "customerName": zod.string().optional(),
  "customerPhone": zod.string().nullish(),
  "customerEmail": zod.string().nullish(),
  "total": zod.coerce.number(),
  "internalCost": zod.coerce.number().optional(),
  "profit": zod.coerce.number().optional(),
  "margin": zod.coerce.number().optional(),
  "targetMargin": zod.coerce.number().min(updateEstimateResponseTargetMarginMin).max(updateEstimateResponseTargetMarginMax).nullish().describe('This quote\'s target margin (%); null uses the target in Settings.'),
  "costBreakdown": zod.object({
  "labour": zod.coerce.number(),
  "materials": zod.coerce.number(),
  "fees": zod.coerce.number()
}).optional().describe('Internal cost totals grouped by parent category for the Internal Workshop popover.'),
  "description": zod.string().nullish(),
  "estimateDate": zod.string().nullish(),
  "validUntil": zod.string().nullish(),
  "depositType": zod.enum(['fixed', 'percent']).optional(),
  "depositValue": zod.coerce.number().optional(),
  "discountType": zod.enum(['fixed', 'percent']).nullish(),
  "discountValue": zod.coerce.number().nullish(),
  "discountAmount": zod.coerce.number().optional(),
  "taxEnabled": zod.boolean().optional(),
  "taxRate": zod.coerce.number().optional(),
  "selectedTaxLines": zod.string().nullish(),
  "linkedInvoiceId": zod.coerce.number().nullish(),
  "isRecurring": zod.boolean().optional(),
  "recurringInterval": zod.string().nullish(),
  "recurringCustomDays": zod.coerce.number().nullish(),
  "recurringStartDate": zod.string().nullish(),
  "recurringEndDate": zod.string().nullish(),
  "recurringNextDate": zod.string().nullish(),
  "recurringParentId": zod.coerce.number().nullish(),
  "createdAt": zod.coerce.date(),
  "updatedAt": zod.coerce.date()
})


/**
 * @summary Delete an estimate
 */
export const DeleteEstimateParams = zod.object({
  "id": zod.coerce.number()
})


/**
 * @summary List all products/services
 */
export const ListProductsQueryParams = zod.object({
  "search": zod.coerce.string().optional(),
  "category": zod.coerce.string().optional()
})

export const ListProductsResponseItem = zod.object({
  "id": zod.coerce.number(),
  "name": zod.string(),
  "description": zod.string().nullish(),
  "unitPrice": zod.coerce.number(),
  "unit": zod.string().nullish(),
  "category": zod.string().nullish(),
  "sku": zod.string().nullish(),
  "taxable": zod.boolean().optional(),
  "productType": zod.string().optional(),
  "createdAt": zod.coerce.date()
})
export const ListProductsResponse = zod.array(ListProductsResponseItem)


/**
 * @summary Create a product/service
 */
export const CreateProductBody = zod.object({
  "name": zod.string(),
  "description": zod.string().nullish(),
  "unitPrice": zod.coerce.number(),
  "unit": zod.string().nullish(),
  "category": zod.string().nullish(),
  "sku": zod.string().nullish(),
  "taxable": zod.boolean().optional(),
  "productType": zod.string().optional()
})


/**
 * @summary Bulk delete products by IDs
 */



export const BulkDeleteProductsBody = zod.object({
  "ids": zod.array(zod.coerce.number()).min(1)
})

export const BulkDeleteProductsResponse = zod.object({
  "deleted": zod.coerce.number()
})


/**
 * @summary Get a single product
 */
export const GetProductParams = zod.object({
  "id": zod.coerce.number()
})

export const GetProductResponse = zod.object({
  "id": zod.coerce.number(),
  "name": zod.string(),
  "description": zod.string().nullish(),
  "unitPrice": zod.coerce.number(),
  "unit": zod.string().nullish(),
  "category": zod.string().nullish(),
  "sku": zod.string().nullish(),
  "taxable": zod.boolean().optional(),
  "productType": zod.string().optional(),
  "createdAt": zod.coerce.date()
})


/**
 * @summary Update a product
 */
export const UpdateProductParams = zod.object({
  "id": zod.coerce.number()
})

export const UpdateProductBody = zod.object({
  "name": zod.string(),
  "description": zod.string().nullish(),
  "unitPrice": zod.coerce.number(),
  "unit": zod.string().nullish(),
  "category": zod.string().nullish(),
  "sku": zod.string().nullish(),
  "taxable": zod.boolean().optional(),
  "productType": zod.string().optional()
})

export const UpdateProductResponse = zod.object({
  "id": zod.coerce.number(),
  "name": zod.string(),
  "description": zod.string().nullish(),
  "unitPrice": zod.coerce.number(),
  "unit": zod.string().nullish(),
  "category": zod.string().nullish(),
  "sku": zod.string().nullish(),
  "taxable": zod.boolean().optional(),
  "productType": zod.string().optional(),
  "createdAt": zod.coerce.date()
})


/**
 * @summary Delete a product
 */
export const DeleteProductParams = zod.object({
  "id": zod.coerce.number()
})


/**
 * @summary Get product usage across estimates
 */
export const GetProductUsageParams = zod.object({
  "id": zod.coerce.number()
})

export const GetProductUsageResponse = zod.object({
  "id": zod.coerce.number(),
  "name": zod.string(),
  "description": zod.string().nullish(),
  "unitPrice": zod.coerce.number(),
  "unit": zod.string().nullish(),
  "category": zod.string().nullish(),
  "sku": zod.string().nullish(),
  "taxable": zod.boolean().optional(),
  "productType": zod.string().optional(),
  "createdAt": zod.coerce.date(),
  "timesUsedOnInvoices": zod.coerce.number(),
  "invoiceRevenue": zod.coerce.number(),
  "timesUsedOnQuotes": zod.coerce.number(),
  "avgQty": zod.coerce.number(),
  "usageHistory": zod.array(zod.object({
  "source": zod.enum(['invoice', 'quote']),
  "documentId": zod.coerce.number(),
  "documentNumber": zod.string().nullish(),
  "documentTitle": zod.string(),
  "customerName": zod.string(),
  "documentDate": zod.string(),
  "status": zod.string(),
  "qty": zod.coerce.number(),
  "lineTotal": zod.coerce.number()
}))
})


/**
 * @summary List default costs for a product
 */
export const ListProductDefaultCostsParams = zod.object({
  "productId": zod.coerce.number()
})

export const ListProductDefaultCostsResponseItem = zod.object({
  "id": zod.coerce.number(),
  "productId": zod.coerce.number(),
  "catalogItemId": zod.coerce.number().nullish(),
  "name": zod.string(),
  "quantity": zod.coerce.number(),
  "unit": zod.string().nullish(),
  "unitCost": zod.coerce.number(),
  "totalCost": zod.coerce.number(),
  "supplier": zod.string().nullish(),
  "notes": zod.string().nullish(),
  "type": zod.enum(['labour', 'materials', 'fees']).nullish()
})
export const ListProductDefaultCostsResponse = zod.array(ListProductDefaultCostsResponseItem)


/**
 * @summary Add a default cost to a product
 */
export const CreateProductDefaultCostParams = zod.object({
  "productId": zod.coerce.number()
})

export const CreateProductDefaultCostBody = zod.object({
  "catalogItemId": zod.coerce.number().nullish(),
  "name": zod.string(),
  "quantity": zod.coerce.number(),
  "unit": zod.string().nullish(),
  "unitCost": zod.coerce.number(),
  "supplier": zod.string().nullish(),
  "notes": zod.string().nullish(),
  "type": zod.enum(['labour', 'materials', 'fees']).optional(),
  "category": zod.string().nullish()
})


/**
 * @summary Update a default cost on a product
 */
export const UpdateProductDefaultCostParams = zod.object({
  "productId": zod.coerce.number(),
  "costId": zod.coerce.number()
})

export const UpdateProductDefaultCostBody = zod.object({
  "catalogItemId": zod.coerce.number().nullish(),
  "name": zod.string(),
  "quantity": zod.coerce.number(),
  "unit": zod.string().nullish(),
  "unitCost": zod.coerce.number(),
  "supplier": zod.string().nullish(),
  "notes": zod.string().nullish(),
  "type": zod.enum(['labour', 'materials', 'fees']).optional(),
  "category": zod.string().nullish()
})

export const UpdateProductDefaultCostResponse = zod.object({
  "id": zod.coerce.number(),
  "productId": zod.coerce.number(),
  "catalogItemId": zod.coerce.number().nullish(),
  "name": zod.string(),
  "quantity": zod.coerce.number(),
  "unit": zod.string().nullish(),
  "unitCost": zod.coerce.number(),
  "totalCost": zod.coerce.number(),
  "supplier": zod.string().nullish(),
  "notes": zod.string().nullish(),
  "type": zod.enum(['labour', 'materials', 'fees']).nullish()
})


/**
 * @summary Delete a default cost from a product
 */
export const DeleteProductDefaultCostParams = zod.object({
  "productId": zod.coerce.number(),
  "costId": zod.coerce.number()
})


/**
 * @summary Get internal catalog item usage across estimates
 */
export const GetInternalCatalogItemUsageParams = zod.object({
  "id": zod.coerce.number()
})

export const GetInternalCatalogItemUsageResponse = zod.object({
  "id": zod.coerce.number(),
  "name": zod.string(),
  "description": zod.string().nullish(),
  "unitCost": zod.coerce.number(),
  "unit": zod.string().nullish(),
  "category": zod.string().nullish(),
  "type": zod.enum(['labour', 'materials', 'fees']),
  "createdAt": zod.coerce.date(),
  "timesUsed": zod.coerce.number(),
  "totalCost": zod.coerce.number(),
  "usageHistory": zod.array(zod.object({
  "estimateId": zod.coerce.number(),
  "estimateNumber": zod.string().nullish(),
  "estimateTitle": zod.string(),
  "customerName": zod.string(),
  "estimateDate": zod.string(),
  "lineItemDescription": zod.string(),
  "qty": zod.coerce.number(),
  "costTotal": zod.coerce.number()
}))
})


/**
 * @summary List line items for an estimate
 */
export const ListLineItemsParams = zod.object({
  "estimateId": zod.coerce.number()
})

export const ListLineItemsResponseItem = zod.object({
  "id": zod.coerce.number(),
  "estimateId": zod.coerce.number(),
  "productId": zod.coerce.number().nullish(),
  "groupId": zod.coerce.number().nullish(),
  "description": zod.string(),
  "quantity": zod.coerce.number(),
  "unitPrice": zod.coerce.number(),
  "total": zod.coerce.number(),
  "sortOrder": zod.coerce.number().optional(),
  "privateNote": zod.string().nullish(),
  "internalCostTotal": zod.coerce.number().optional(),
  "productName": zod.string().nullish(),
  "materials": zod.array(zod.object({
  "id": zod.coerce.number(),
  "lineItemId": zod.coerce.number(),
  "catalogItemId": zod.coerce.number().nullish(),
  "name": zod.string(),
  "quantity": zod.coerce.number(),
  "unit": zod.string().nullish(),
  "unitCost": zod.coerce.number(),
  "totalCost": zod.coerce.number(),
  "supplier": zod.string().nullish(),
  "notes": zod.string().nullish(),
  "type": zod.enum(['labour', 'materials', 'fees']),
  "fromProductDefaultId": zod.coerce.number().nullish()
})).optional()
})
export const ListLineItemsResponse = zod.array(ListLineItemsResponseItem)


/**
 * @summary Add a line item
 */
export const CreateLineItemParams = zod.object({
  "estimateId": zod.coerce.number()
})

export const CreateLineItemBody = zod.object({
  "productId": zod.coerce.number().nullish(),
  "groupId": zod.coerce.number().nullish(),
  "description": zod.string(),
  "quantity": zod.coerce.number(),
  "unitPrice": zod.coerce.number(),
  "sortOrder": zod.coerce.number().optional(),
  "privateNote": zod.string().nullish()
})


/**
 * @summary Update a line item
 */
export const UpdateLineItemParams = zod.object({
  "estimateId": zod.coerce.number(),
  "id": zod.coerce.number()
})

export const UpdateLineItemBody = zod.object({
  "productId": zod.coerce.number().nullish(),
  "groupId": zod.coerce.number().nullish(),
  "description": zod.string(),
  "quantity": zod.coerce.number(),
  "unitPrice": zod.coerce.number(),
  "sortOrder": zod.coerce.number().optional(),
  "privateNote": zod.string().nullish()
})

export const UpdateLineItemResponse = zod.object({
  "id": zod.coerce.number(),
  "estimateId": zod.coerce.number(),
  "productId": zod.coerce.number().nullish(),
  "groupId": zod.coerce.number().nullish(),
  "description": zod.string(),
  "quantity": zod.coerce.number(),
  "unitPrice": zod.coerce.number(),
  "total": zod.coerce.number(),
  "sortOrder": zod.coerce.number().optional(),
  "privateNote": zod.string().nullish(),
  "internalCostTotal": zod.coerce.number().optional(),
  "productName": zod.string().nullish(),
  "materials": zod.array(zod.object({
  "id": zod.coerce.number(),
  "lineItemId": zod.coerce.number(),
  "catalogItemId": zod.coerce.number().nullish(),
  "name": zod.string(),
  "quantity": zod.coerce.number(),
  "unit": zod.string().nullish(),
  "unitCost": zod.coerce.number(),
  "totalCost": zod.coerce.number(),
  "supplier": zod.string().nullish(),
  "notes": zod.string().nullish(),
  "type": zod.enum(['labour', 'materials', 'fees']),
  "fromProductDefaultId": zod.coerce.number().nullish()
})).optional()
})


/**
 * @summary Delete a line item
 */
export const DeleteLineItemParams = zod.object({
  "estimateId": zod.coerce.number(),
  "id": zod.coerce.number()
})


/**
 * @summary List internal costs for a line item
 */
export const ListCostsParams = zod.object({
  "estimateId": zod.coerce.number(),
  "lineItemId": zod.coerce.number()
})

export const ListCostsResponseItem = zod.object({
  "id": zod.coerce.number(),
  "lineItemId": zod.coerce.number(),
  "catalogItemId": zod.coerce.number().nullish(),
  "name": zod.string(),
  "quantity": zod.coerce.number(),
  "unit": zod.string().nullish(),
  "unitCost": zod.coerce.number(),
  "totalCost": zod.coerce.number(),
  "supplier": zod.string().nullish(),
  "notes": zod.string().nullish(),
  "type": zod.enum(['labour', 'materials', 'fees']),
  "fromProductDefaultId": zod.coerce.number().nullish()
})
export const ListCostsResponse = zod.array(ListCostsResponseItem)


/**
 * @summary Add an internal cost to a line item
 */
export const CreateCostParams = zod.object({
  "estimateId": zod.coerce.number(),
  "lineItemId": zod.coerce.number()
})

export const CreateCostBody = zod.object({
  "catalogItemId": zod.coerce.number().nullish(),
  "name": zod.string(),
  "quantity": zod.coerce.number(),
  "unit": zod.string().nullish(),
  "unitCost": zod.coerce.number(),
  "supplier": zod.string().nullish(),
  "notes": zod.string().nullish(),
  "type": zod.enum(['labour', 'materials', 'fees']).optional(),
  "category": zod.string().nullish()
})


/**
 * @summary Update an internal cost
 */
export const UpdateCostParams = zod.object({
  "estimateId": zod.coerce.number(),
  "lineItemId": zod.coerce.number(),
  "id": zod.coerce.number()
})

export const UpdateCostBody = zod.object({
  "catalogItemId": zod.coerce.number().nullish(),
  "name": zod.string(),
  "quantity": zod.coerce.number(),
  "unit": zod.string().nullish(),
  "unitCost": zod.coerce.number(),
  "supplier": zod.string().nullish(),
  "notes": zod.string().nullish(),
  "type": zod.enum(['labour', 'materials', 'fees']).optional(),
  "category": zod.string().nullish()
})

export const UpdateCostResponse = zod.object({
  "id": zod.coerce.number(),
  "lineItemId": zod.coerce.number(),
  "catalogItemId": zod.coerce.number().nullish(),
  "name": zod.string(),
  "quantity": zod.coerce.number(),
  "unit": zod.string().nullish(),
  "unitCost": zod.coerce.number(),
  "totalCost": zod.coerce.number(),
  "supplier": zod.string().nullish(),
  "notes": zod.string().nullish(),
  "type": zod.enum(['labour', 'materials', 'fees']),
  "fromProductDefaultId": zod.coerce.number().nullish()
})


/**
 * @summary Delete an internal cost
 */
export const DeleteCostParams = zod.object({
  "estimateId": zod.coerce.number(),
  "lineItemId": zod.coerce.number(),
  "id": zod.coerce.number()
})


/**
 * @summary Set or clear the private note on a line item
 */
export const UpdateLineItemNoteParams = zod.object({
  "estimateId": zod.coerce.number(),
  "lineItemId": zod.coerce.number()
})

export const UpdateLineItemNoteBody = zod.object({
  "privateNote": zod.string().nullish()
})

export const UpdateLineItemNoteResponse = zod.object({
  "id": zod.coerce.number(),
  "estimateId": zod.coerce.number(),
  "productId": zod.coerce.number().nullish(),
  "groupId": zod.coerce.number().nullish(),
  "description": zod.string(),
  "quantity": zod.coerce.number(),
  "unitPrice": zod.coerce.number(),
  "total": zod.coerce.number(),
  "sortOrder": zod.coerce.number().optional(),
  "privateNote": zod.string().nullish(),
  "internalCostTotal": zod.coerce.number().optional(),
  "productName": zod.string().nullish(),
  "materials": zod.array(zod.object({
  "id": zod.coerce.number(),
  "lineItemId": zod.coerce.number(),
  "catalogItemId": zod.coerce.number().nullish(),
  "name": zod.string(),
  "quantity": zod.coerce.number(),
  "unit": zod.string().nullish(),
  "unitCost": zod.coerce.number(),
  "totalCost": zod.coerce.number(),
  "supplier": zod.string().nullish(),
  "notes": zod.string().nullish(),
  "type": zod.enum(['labour', 'materials', 'fees']),
  "fromProductDefaultId": zod.coerce.number().nullish()
})).optional()
})


/**
 * @summary List line item groups for an estimate
 */
export const ListLineItemGroupsParams = zod.object({
  "estimateId": zod.coerce.number()
})

export const ListLineItemGroupsResponseItem = zod.object({
  "id": zod.coerce.number(),
  "estimateId": zod.coerce.number(),
  "name": zod.string(),
  "sortOrder": zod.coerce.number(),
  "collapsedByDefault": zod.coerce.number(),
  "accentColor": zod.string().nullish()
})
export const ListLineItemGroupsResponse = zod.array(ListLineItemGroupsResponseItem)


/**
 * @summary Create a new line item group
 */
export const CreateLineItemGroupParams = zod.object({
  "estimateId": zod.coerce.number()
})

export const CreateLineItemGroupBody = zod.object({
  "name": zod.string(),
  "sortOrder": zod.coerce.number().optional(),
  "collapsedByDefault": zod.coerce.number().optional(),
  "accentColor": zod.string().nullish()
})


/**
 * @summary Update a line item group
 */
export const UpdateLineItemGroupParams = zod.object({
  "estimateId": zod.coerce.number(),
  "id": zod.coerce.number()
})

export const UpdateLineItemGroupBody = zod.object({
  "name": zod.string().optional(),
  "sortOrder": zod.coerce.number().optional(),
  "collapsedByDefault": zod.coerce.number().optional(),
  "accentColor": zod.string().nullish()
})

export const UpdateLineItemGroupResponse = zod.object({
  "id": zod.coerce.number(),
  "estimateId": zod.coerce.number(),
  "name": zod.string(),
  "sortOrder": zod.coerce.number(),
  "collapsedByDefault": zod.coerce.number(),
  "accentColor": zod.string().nullish()
})


/**
 * @summary Delete a line item group (ungrouping its items)
 */
export const DeleteLineItemGroupParams = zod.object({
  "estimateId": zod.coerce.number(),
  "id": zod.coerce.number()
})


/**
 * @summary List all internal catalog items
 */
export const ListInternalCatalogResponseItem = zod.object({
  "id": zod.coerce.number(),
  "name": zod.string(),
  "description": zod.string().nullish(),
  "unitCost": zod.coerce.number(),
  "unit": zod.string().nullish(),
  "category": zod.string().nullish(),
  "type": zod.enum(['labour', 'materials', 'fees']),
  "createdAt": zod.coerce.date()
})
export const ListInternalCatalogResponse = zod.array(ListInternalCatalogResponseItem)


/**
 * @summary Create a new internal catalog item
 */
export const CreateInternalCatalogItemBody = zod.object({
  "name": zod.string(),
  "description": zod.string().nullish(),
  "unitCost": zod.coerce.number(),
  "unit": zod.string().nullish(),
  "category": zod.string().nullish(),
  "type": zod.enum(['labour', 'materials', 'fees']).optional()
})


/**
 * @summary Bulk delete internal catalog items by IDs
 */



export const BulkDeleteInternalCatalogItemsBody = zod.object({
  "ids": zod.array(zod.coerce.number()).min(1)
})

export const BulkDeleteInternalCatalogItemsResponse = zod.object({
  "deleted": zod.coerce.number()
})


/**
 * @summary Update an internal catalog item
 */
export const UpdateInternalCatalogItemParams = zod.object({
  "id": zod.coerce.number()
})

export const UpdateInternalCatalogItemBody = zod.object({
  "name": zod.string(),
  "description": zod.string().nullish(),
  "unitCost": zod.coerce.number(),
  "unit": zod.string().nullish(),
  "category": zod.string().nullish(),
  "type": zod.enum(['labour', 'materials', 'fees']).optional()
})

export const UpdateInternalCatalogItemResponse = zod.object({
  "id": zod.coerce.number(),
  "name": zod.string(),
  "description": zod.string().nullish(),
  "unitCost": zod.coerce.number(),
  "unit": zod.string().nullish(),
  "category": zod.string().nullish(),
  "type": zod.enum(['labour', 'materials', 'fees']),
  "createdAt": zod.coerce.date()
})


/**
 * @summary Delete an internal catalog item
 */
export const DeleteInternalCatalogItemParams = zod.object({
  "id": zod.coerce.number()
})


/**
 * @summary Get dashboard summary stats
 */
export const GetDashboardSummaryQueryParams = zod.object({
  "startDate": zod.coerce.string().optional(),
  "endDate": zod.coerce.string().optional()
})

export const GetDashboardSummaryResponse = zod.object({
  "totalEstimates": zod.coerce.number(),
  "totalCustomers": zod.coerce.number(),
  "totalValue": zod.coerce.number(),
  "acceptedValue": zod.coerce.number(),
  "pendingValue": zod.coerce.number(),
  "acceptanceRate": zod.coerce.number(),
  "averageMargin": zod.coerce.number(),
  "acceptedProfit": zod.coerce.number()
})


/**
 * @summary Get recent estimates
 */
export const getRecentEstimatesQueryLimitDefault = 5;

export const GetRecentEstimatesQueryParams = zod.object({
  "limit": zod.coerce.number().default(getRecentEstimatesQueryLimitDefault),
  "startDate": zod.coerce.string().optional(),
  "endDate": zod.coerce.string().optional()
})

export const getRecentEstimatesResponseTargetMarginMin = 0;
export const getRecentEstimatesResponseTargetMarginMax = 90;



export const GetRecentEstimatesResponseItem = zod.object({
  "id": zod.coerce.number(),
  "estimateNumber": zod.string().nullish(),
  "title": zod.string(),
  "status": zod.enum(['draft', 'sent', 'accepted', 'declined', 'converted']),
  "customerId": zod.coerce.number(),
  "customerName": zod.string().optional(),
  "customerPhone": zod.string().nullish(),
  "customerEmail": zod.string().nullish(),
  "total": zod.coerce.number(),
  "internalCost": zod.coerce.number().optional(),
  "profit": zod.coerce.number().optional(),
  "margin": zod.coerce.number().optional(),
  "targetMargin": zod.coerce.number().min(getRecentEstimatesResponseTargetMarginMin).max(getRecentEstimatesResponseTargetMarginMax).nullish().describe('This quote\'s target margin (%); null uses the target in Settings.'),
  "costBreakdown": zod.object({
  "labour": zod.coerce.number(),
  "materials": zod.coerce.number(),
  "fees": zod.coerce.number()
}).optional().describe('Internal cost totals grouped by parent category for the Internal Workshop popover.'),
  "description": zod.string().nullish(),
  "estimateDate": zod.string().nullish(),
  "validUntil": zod.string().nullish(),
  "depositType": zod.enum(['fixed', 'percent']).optional(),
  "depositValue": zod.coerce.number().optional(),
  "discountType": zod.enum(['fixed', 'percent']).nullish(),
  "discountValue": zod.coerce.number().nullish(),
  "discountAmount": zod.coerce.number().optional(),
  "taxEnabled": zod.boolean().optional(),
  "taxRate": zod.coerce.number().optional(),
  "selectedTaxLines": zod.string().nullish(),
  "linkedInvoiceId": zod.coerce.number().nullish(),
  "isRecurring": zod.boolean().optional(),
  "recurringInterval": zod.string().nullish(),
  "recurringCustomDays": zod.coerce.number().nullish(),
  "recurringStartDate": zod.string().nullish(),
  "recurringEndDate": zod.string().nullish(),
  "recurringNextDate": zod.string().nullish(),
  "recurringParentId": zod.coerce.number().nullish(),
  "createdAt": zod.coerce.date(),
  "updatedAt": zod.coerce.date()
})
export const GetRecentEstimatesResponse = zod.array(GetRecentEstimatesResponseItem)


/**
 * @summary List recent account activity events (last 90 days)
 */
export const listActivityQueryPageDefault = 1;
export const listActivityQueryLimitDefault = 25;

export const ListActivityQueryParams = zod.object({
  "page": zod.coerce.number().default(listActivityQueryPageDefault),
  "limit": zod.coerce.number().default(listActivityQueryLimitDefault)
})

export const ListActivityResponse = zod.object({
  "items": zod.array(zod.object({
  "id": zod.coerce.number(),
  "eventType": zod.string(),
  "summary": zod.string(),
  "metadata": zod.record(zod.string(), zod.unknown()).nullish(),
  "createdAt": zod.coerce.date()
})),
  "page": zod.coerce.number(),
  "limit": zod.coerce.number(),
  "hasMore": zod.boolean()
})


/**
 * @summary List billing events (quote expirations, invoice due/paid/recurring dates) within a date range
 */
export const ListCalendarBillingEventsQueryParams = zod.object({
  "startDate": zod.coerce.string(),
  "endDate": zod.coerce.string()
})

export const ListCalendarBillingEventsResponseItem = zod.object({
  "date": zod.string().describe('Event date (YYYY-MM-DD)'),
  "eventType": zod.enum(['quote_expiration', 'invoice_due', 'invoice_recurring', 'invoice_paid']),
  "documentType": zod.enum(['estimate', 'invoice']),
  "documentId": zod.coerce.number(),
  "documentNumber": zod.string().nullish(),
  "title": zod.string(),
  "customerName": zod.string().nullish(),
  "amount": zod.coerce.number(),
  "status": zod.string().nullish()
})
export const ListCalendarBillingEventsResponse = zod.array(ListCalendarBillingEventsResponseItem)


/**
 * @summary Get company settings
 */
export const getSettingsResponseTargetMarginMin = 0;
export const getSettingsResponseTargetMarginMax = 90;



export const GetSettingsResponse = zod.object({
  "companyName": zod.string().nullish(),
  "address": zod.string().nullish(),
  "addressLine1": zod.string().nullish(),
  "addressLine2": zod.string().nullish(),
  "city": zod.string().nullish(),
  "state": zod.string().nullish(),
  "postalCode": zod.string().nullish(),
  "country": zod.string().nullish(),
  "phone": zod.string().nullish(),
  "email": zod.string().nullish(),
  "website": zod.string().nullish(),
  "tagline": zod.string().nullish(),
  "logoBase64": zod.string().nullish(),
  "accentColor": zod.string().nullish(),
  "sidebarColor": zod.string().nullish(),
  "documentTitle": zod.string().nullish(),
  "columnConfig": zod.string().nullish(),
  "taxLines": zod.string().nullish(),
  "depositPercent": zod.coerce.number().nullish(),
  "currencyLabel": zod.string().nullish(),
  "termsAndNotes": zod.string().nullish(),
  "invoiceDocumentTitle": zod.string().nullish(),
  "invoiceAccentColor": zod.string().nullish(),
  "invoiceCurrencyLabel": zod.string().nullish(),
  "invoiceColumnConfig": zod.string().nullish(),
  "invoiceTermsAndNotes": zod.string().nullish(),
  "invoicePdfFooter": zod.string().nullish(),
  "pdfFooter": zod.string().nullish(),
  "replyToEmail": zod.string().nullish(),
  "timezone": zod.string().nullish(),
  "defaultQuoteEmailSubject": zod.string().nullish(),
  "defaultQuoteEmailBody": zod.string().nullish(),
  "defaultInvoiceEmailSubject": zod.string().nullish(),
  "defaultInvoiceEmailBody": zod.string().nullish(),
  "notifyOverdueInvoices": zod.boolean().optional(),
  "notifyTodoReminders": zod.boolean().optional(),
  "todoReminderLeadDays": zod.coerce.number().optional(),
  "notifyRecurringGenerated": zod.boolean().optional(),
  "notifyPaymentReceived": zod.boolean().optional(),
  "notificationHour": zod.coerce.number().optional(),
  "targetMargin": zod.coerce.number().min(getSettingsResponseTargetMarginMin).max(getSettingsResponseTargetMarginMax).optional().describe('Margin (%) the contractor aims for on every quote. Defaults to 30.'),
  "emailPreferences": zod.record(zod.string(), zod.boolean()).nullish().describe('Marketing email opt-in flags keyed by email type (e.g. reEngagement). Defaults to {reEngagement: true}.'),
  "serviceAgreementFileName": zod.string().nullish(),
  "serviceAgreementContentSize": zod.coerce.number().nullish(),
  "serviceAgreementUploadedAt": zod.coerce.date().nullish()
})


/**
 * @summary Update company settings
 */
export const updateSettingsBodyTargetMarginMin = 0;
export const updateSettingsBodyTargetMarginMax = 90;



export const UpdateSettingsBody = zod.object({
  "companyName": zod.string().nullish(),
  "address": zod.string().nullish(),
  "addressLine1": zod.string().nullish(),
  "addressLine2": zod.string().nullish(),
  "city": zod.string().nullish(),
  "state": zod.string().nullish(),
  "postalCode": zod.string().nullish(),
  "country": zod.string().nullish(),
  "phone": zod.string().nullish(),
  "email": zod.string().nullish(),
  "website": zod.string().nullish(),
  "tagline": zod.string().nullish(),
  "logoBase64": zod.string().nullish(),
  "accentColor": zod.string().nullish(),
  "sidebarColor": zod.string().nullish(),
  "documentTitle": zod.string().nullish(),
  "columnConfig": zod.string().nullish(),
  "taxLines": zod.string().nullish(),
  "depositPercent": zod.coerce.number().nullish(),
  "currencyLabel": zod.string().nullish(),
  "termsAndNotes": zod.string().nullish(),
  "invoiceDocumentTitle": zod.string().nullish(),
  "invoiceAccentColor": zod.string().nullish(),
  "invoiceCurrencyLabel": zod.string().nullish(),
  "invoiceColumnConfig": zod.string().nullish(),
  "invoiceTermsAndNotes": zod.string().nullish(),
  "invoicePdfFooter": zod.string().nullish(),
  "pdfFooter": zod.string().nullish(),
  "replyToEmail": zod.string().nullish(),
  "timezone": zod.string().nullish(),
  "defaultQuoteEmailSubject": zod.string().nullish(),
  "defaultQuoteEmailBody": zod.string().nullish(),
  "defaultInvoiceEmailSubject": zod.string().nullish(),
  "defaultInvoiceEmailBody": zod.string().nullish(),
  "notifyOverdueInvoices": zod.boolean().optional(),
  "notifyTodoReminders": zod.boolean().optional(),
  "todoReminderLeadDays": zod.coerce.number().optional(),
  "notifyRecurringGenerated": zod.boolean().optional(),
  "notifyPaymentReceived": zod.boolean().optional(),
  "notificationHour": zod.coerce.number().optional(),
  "targetMargin": zod.coerce.number().min(updateSettingsBodyTargetMarginMin).max(updateSettingsBodyTargetMarginMax).optional().describe('Margin (%) the contractor aims for on every quote. Defaults to 30.'),
  "emailPreferences": zod.record(zod.string(), zod.boolean()).nullish().describe('Marketing email opt-in flags keyed by email type (e.g. reEngagement).')
})

export const updateSettingsResponseTargetMarginMin = 0;
export const updateSettingsResponseTargetMarginMax = 90;



export const UpdateSettingsResponse = zod.object({
  "companyName": zod.string().nullish(),
  "address": zod.string().nullish(),
  "addressLine1": zod.string().nullish(),
  "addressLine2": zod.string().nullish(),
  "city": zod.string().nullish(),
  "state": zod.string().nullish(),
  "postalCode": zod.string().nullish(),
  "country": zod.string().nullish(),
  "phone": zod.string().nullish(),
  "email": zod.string().nullish(),
  "website": zod.string().nullish(),
  "tagline": zod.string().nullish(),
  "logoBase64": zod.string().nullish(),
  "accentColor": zod.string().nullish(),
  "sidebarColor": zod.string().nullish(),
  "documentTitle": zod.string().nullish(),
  "columnConfig": zod.string().nullish(),
  "taxLines": zod.string().nullish(),
  "depositPercent": zod.coerce.number().nullish(),
  "currencyLabel": zod.string().nullish(),
  "termsAndNotes": zod.string().nullish(),
  "invoiceDocumentTitle": zod.string().nullish(),
  "invoiceAccentColor": zod.string().nullish(),
  "invoiceCurrencyLabel": zod.string().nullish(),
  "invoiceColumnConfig": zod.string().nullish(),
  "invoiceTermsAndNotes": zod.string().nullish(),
  "invoicePdfFooter": zod.string().nullish(),
  "pdfFooter": zod.string().nullish(),
  "replyToEmail": zod.string().nullish(),
  "timezone": zod.string().nullish(),
  "defaultQuoteEmailSubject": zod.string().nullish(),
  "defaultQuoteEmailBody": zod.string().nullish(),
  "defaultInvoiceEmailSubject": zod.string().nullish(),
  "defaultInvoiceEmailBody": zod.string().nullish(),
  "notifyOverdueInvoices": zod.boolean().optional(),
  "notifyTodoReminders": zod.boolean().optional(),
  "todoReminderLeadDays": zod.coerce.number().optional(),
  "notifyRecurringGenerated": zod.boolean().optional(),
  "notifyPaymentReceived": zod.boolean().optional(),
  "notificationHour": zod.coerce.number().optional(),
  "targetMargin": zod.coerce.number().min(updateSettingsResponseTargetMarginMin).max(updateSettingsResponseTargetMarginMax).optional().describe('Margin (%) the contractor aims for on every quote. Defaults to 30.'),
  "emailPreferences": zod.record(zod.string(), zod.boolean()).nullish().describe('Marketing email opt-in flags keyed by email type (e.g. reEngagement). Defaults to {reEngagement: true}.'),
  "serviceAgreementFileName": zod.string().nullish(),
  "serviceAgreementContentSize": zod.coerce.number().nullish(),
  "serviceAgreementUploadedAt": zod.coerce.date().nullish()
})


/**
 * @summary Finalize and persist a newly uploaded service agreement PDF
 */




export const SaveServiceAgreementBody = zod.object({
  "objectPath": zod.string().min(1).describe('Object path returned by \/storage\/uploads\/request-url after the PDF has been uploaded.'),
  "fileName": zod.string().min(1).describe('Original filename of the uploaded PDF.')
})

export const saveServiceAgreementResponseTargetMarginMin = 0;
export const saveServiceAgreementResponseTargetMarginMax = 90;



export const SaveServiceAgreementResponse = zod.object({
  "companyName": zod.string().nullish(),
  "address": zod.string().nullish(),
  "addressLine1": zod.string().nullish(),
  "addressLine2": zod.string().nullish(),
  "city": zod.string().nullish(),
  "state": zod.string().nullish(),
  "postalCode": zod.string().nullish(),
  "country": zod.string().nullish(),
  "phone": zod.string().nullish(),
  "email": zod.string().nullish(),
  "website": zod.string().nullish(),
  "tagline": zod.string().nullish(),
  "logoBase64": zod.string().nullish(),
  "accentColor": zod.string().nullish(),
  "sidebarColor": zod.string().nullish(),
  "documentTitle": zod.string().nullish(),
  "columnConfig": zod.string().nullish(),
  "taxLines": zod.string().nullish(),
  "depositPercent": zod.coerce.number().nullish(),
  "currencyLabel": zod.string().nullish(),
  "termsAndNotes": zod.string().nullish(),
  "invoiceDocumentTitle": zod.string().nullish(),
  "invoiceAccentColor": zod.string().nullish(),
  "invoiceCurrencyLabel": zod.string().nullish(),
  "invoiceColumnConfig": zod.string().nullish(),
  "invoiceTermsAndNotes": zod.string().nullish(),
  "invoicePdfFooter": zod.string().nullish(),
  "pdfFooter": zod.string().nullish(),
  "replyToEmail": zod.string().nullish(),
  "timezone": zod.string().nullish(),
  "defaultQuoteEmailSubject": zod.string().nullish(),
  "defaultQuoteEmailBody": zod.string().nullish(),
  "defaultInvoiceEmailSubject": zod.string().nullish(),
  "defaultInvoiceEmailBody": zod.string().nullish(),
  "notifyOverdueInvoices": zod.boolean().optional(),
  "notifyTodoReminders": zod.boolean().optional(),
  "todoReminderLeadDays": zod.coerce.number().optional(),
  "notifyRecurringGenerated": zod.boolean().optional(),
  "notifyPaymentReceived": zod.boolean().optional(),
  "notificationHour": zod.coerce.number().optional(),
  "targetMargin": zod.coerce.number().min(saveServiceAgreementResponseTargetMarginMin).max(saveServiceAgreementResponseTargetMarginMax).optional().describe('Margin (%) the contractor aims for on every quote. Defaults to 30.'),
  "emailPreferences": zod.record(zod.string(), zod.boolean()).nullish().describe('Marketing email opt-in flags keyed by email type (e.g. reEngagement). Defaults to {reEngagement: true}.'),
  "serviceAgreementFileName": zod.string().nullish(),
  "serviceAgreementContentSize": zod.coerce.number().nullish(),
  "serviceAgreementUploadedAt": zod.coerce.date().nullish()
})


/**
 * @summary Remove the current service agreement PDF
 */
export const deleteServiceAgreementResponseTargetMarginMin = 0;
export const deleteServiceAgreementResponseTargetMarginMax = 90;



export const DeleteServiceAgreementResponse = zod.object({
  "companyName": zod.string().nullish(),
  "address": zod.string().nullish(),
  "addressLine1": zod.string().nullish(),
  "addressLine2": zod.string().nullish(),
  "city": zod.string().nullish(),
  "state": zod.string().nullish(),
  "postalCode": zod.string().nullish(),
  "country": zod.string().nullish(),
  "phone": zod.string().nullish(),
  "email": zod.string().nullish(),
  "website": zod.string().nullish(),
  "tagline": zod.string().nullish(),
  "logoBase64": zod.string().nullish(),
  "accentColor": zod.string().nullish(),
  "sidebarColor": zod.string().nullish(),
  "documentTitle": zod.string().nullish(),
  "columnConfig": zod.string().nullish(),
  "taxLines": zod.string().nullish(),
  "depositPercent": zod.coerce.number().nullish(),
  "currencyLabel": zod.string().nullish(),
  "termsAndNotes": zod.string().nullish(),
  "invoiceDocumentTitle": zod.string().nullish(),
  "invoiceAccentColor": zod.string().nullish(),
  "invoiceCurrencyLabel": zod.string().nullish(),
  "invoiceColumnConfig": zod.string().nullish(),
  "invoiceTermsAndNotes": zod.string().nullish(),
  "invoicePdfFooter": zod.string().nullish(),
  "pdfFooter": zod.string().nullish(),
  "replyToEmail": zod.string().nullish(),
  "timezone": zod.string().nullish(),
  "defaultQuoteEmailSubject": zod.string().nullish(),
  "defaultQuoteEmailBody": zod.string().nullish(),
  "defaultInvoiceEmailSubject": zod.string().nullish(),
  "defaultInvoiceEmailBody": zod.string().nullish(),
  "notifyOverdueInvoices": zod.boolean().optional(),
  "notifyTodoReminders": zod.boolean().optional(),
  "todoReminderLeadDays": zod.coerce.number().optional(),
  "notifyRecurringGenerated": zod.boolean().optional(),
  "notifyPaymentReceived": zod.boolean().optional(),
  "notificationHour": zod.coerce.number().optional(),
  "targetMargin": zod.coerce.number().min(deleteServiceAgreementResponseTargetMarginMin).max(deleteServiceAgreementResponseTargetMarginMax).optional().describe('Margin (%) the contractor aims for on every quote. Defaults to 30.'),
  "emailPreferences": zod.record(zod.string(), zod.boolean()).nullish().describe('Marketing email opt-in flags keyed by email type (e.g. reEngagement). Defaults to {reEngagement: true}.'),
  "serviceAgreementFileName": zod.string().nullish(),
  "serviceAgreementContentSize": zod.coerce.number().nullish(),
  "serviceAgreementUploadedAt": zod.coerce.date().nullish()
})


/**
 * @summary List all todos
 */
export const ListTodosResponseItem = zod.object({
  "id": zod.coerce.number(),
  "label": zod.string(),
  "completed": zod.boolean(),
  "deadline": zod.string().nullish(),
  "createdAt": zod.coerce.date()
})
export const ListTodosResponse = zod.array(ListTodosResponseItem)


/**
 * @summary Create a todo
 */
export const CreateTodoBody = zod.object({
  "label": zod.string(),
  "deadline": zod.string().nullish()
})


/**
 * @summary Update a todo
 */
export const PatchTodoParams = zod.object({
  "id": zod.coerce.number()
})

export const PatchTodoBody = zod.object({
  "label": zod.string().optional(),
  "completed": zod.boolean().optional(),
  "deadline": zod.string().nullish()
})

export const PatchTodoResponse = zod.object({
  "id": zod.coerce.number(),
  "label": zod.string(),
  "completed": zod.boolean(),
  "deadline": zod.string().nullish(),
  "createdAt": zod.coerce.date()
})


/**
 * @summary Delete a todo
 */
export const DeleteTodoParams = zod.object({
  "id": zod.coerce.number()
})


/**
 * Creates a quote or invoice (plus its customer, line items and internal cost rows) from the draft the public free generator hands to the signup page. Used once, right after the visitor's first sign-in.
 *
 * @summary Import a draft from the free quote / invoice generator on quotrak.com
 */
export const ImportFreeBuilderDraftBody = zod.object({
  "mode": zod.enum(['quote', 'invoice']),
  "draft": zod.object({
  "number": zod.string().optional(),
  "title": zod.string().optional(),
  "company": zod.string().optional(),
  "companyDetails": zod.string().optional(),
  "customer": zod.string().optional(),
  "customerDetails": zod.string().optional(),
  "currency": zod.string().optional(),
  "estimateDate": zod.string().optional(),
  "secondDate": zod.string().optional().describe('Valid-until for a quote, due date for an invoice'),
  "description": zod.string().optional(),
  "termsAndNotes": zod.string().optional(),
  "taxLabel": zod.string().optional(),
  "taxRate": zod.union([zod.coerce.number(),zod.string()]).optional(),
  "discountType": zod.enum(['fixed', 'percent']).optional(),
  "discountValue": zod.union([zod.coerce.number(),zod.string()]).optional(),
  "depositType": zod.enum(['fixed', 'percent']).optional(),
  "depositValue": zod.union([zod.coerce.number(),zod.string()]).optional(),
  "lineItems": zod.array(zod.object({
  "name": zod.string().optional(),
  "description": zod.string().optional(),
  "quantity": zod.union([zod.coerce.number(),zod.string()]).optional(),
  "unitPrice": zod.union([zod.coerce.number(),zod.string()]).optional(),
  "privateNote": zod.string().optional(),
  "costs": zod.array(zod.object({
  "type": zod.string().optional().describe('Labour, Materials or Fees (case-insensitive)'),
  "name": zod.string().optional(),
  "quantity": zod.union([zod.coerce.number(),zod.string()]),
  "unitCost": zod.union([zod.coerce.number(),zod.string()])
})).optional()
}))
}).describe('The draft exactly as js\/builder.js on quotrak.com stores it (extra keys are ignored).')
})


/**
 * @summary Bulk import customers from rows
 */
export const ImportCustomersBody = zod.object({
  "rows": zod.array(zod.object({

}).passthrough())
})


/**
 * @summary Bulk import products from rows
 */
export const ImportProductsBody = zod.object({
  "rows": zod.array(zod.object({

}).passthrough())
})


/**
 * @summary Bulk import internal catalog items from rows
 */
export const ImportInternalCatalogBody = zod.object({
  "rows": zod.array(zod.object({

}).passthrough())
})


/**
 * @summary Get estimate counts grouped by status
 */
export const GetEstimatesByStatusQueryParams = zod.object({
  "startDate": zod.coerce.string().optional(),
  "endDate": zod.coerce.string().optional()
})

export const GetEstimatesByStatusResponseItem = zod.object({
  "status": zod.string(),
  "count": zod.coerce.number()
})
export const GetEstimatesByStatusResponse = zod.array(GetEstimatesByStatusResponseItem)


/**
 * @summary Get profit for each estimate ordered by date
 */
export const GetProfitPerEstimateQueryParams = zod.object({
  "startDate": zod.coerce.string().optional(),
  "endDate": zod.coerce.string().optional()
})

export const GetProfitPerEstimateResponseItem = zod.object({
  "estimateNumber": zod.string().nullish(),
  "title": zod.string(),
  "profit": zod.coerce.number(),
  "margin": zod.coerce.number(),
  "date": zod.coerce.date()
})
export const GetProfitPerEstimateResponse = zod.array(GetProfitPerEstimateResponseItem)


/**
 * @summary Request a presigned URL for file upload
 */





export const RequestUploadUrlBody = zod.object({
  "name": zod.string().min(1),
  "size": zod.coerce.number().min(1),
  "contentType": zod.string().min(1)
})






export const RequestUploadUrlResponse = zod.object({
  "uploadURL": zod.string().url(),
  "objectPath": zod.string(),
  "metadata": zod.object({
  "name": zod.string().min(1),
  "size": zod.coerce.number().min(1),
  "contentType": zod.string().min(1)
}).optional()
})


/**
 * @summary Serve a public asset from PUBLIC_OBJECT_SEARCH_PATHS
 */
export const GetPublicObjectParams = zod.object({
  "filePath": zod.coerce.string()
})


/**
 * @summary Serve an object entity from PRIVATE_OBJECT_DIR
 */
export const GetStorageObjectParams = zod.object({
  "objectPath": zod.coerce.string()
})


/**
 * @summary List attachments for an estimate
 */
export const ListAttachmentsParams = zod.object({
  "estimateId": zod.coerce.number()
})

export const ListAttachmentsResponseItem = zod.object({
  "id": zod.coerce.number(),
  "estimateId": zod.coerce.number(),
  "fileName": zod.string(),
  "contentType": zod.string(),
  "objectPath": zod.string(),
  "createdAt": zod.coerce.date()
})
export const ListAttachmentsResponse = zod.array(ListAttachmentsResponseItem)


/**
 * @summary Save attachment metadata after upload
 */
export const CreateAttachmentParams = zod.object({
  "estimateId": zod.coerce.number()
})

export const CreateAttachmentBody = zod.object({
  "fileName": zod.string(),
  "contentType": zod.string(),
  "objectPath": zod.string()
})


/**
 * @summary Delete an attachment (metadata + object from storage)
 */
export const DeleteAttachmentParams = zod.object({
  "estimateId": zod.coerce.number(),
  "attachmentId": zod.coerce.number()
})


/**
 * @summary List attachments for an invoice
 */
export const ListInvoiceAttachmentsParams = zod.object({
  "invoiceId": zod.coerce.number()
})

export const ListInvoiceAttachmentsResponseItem = zod.object({
  "id": zod.coerce.number(),
  "invoiceId": zod.coerce.number(),
  "fileName": zod.string(),
  "contentType": zod.string(),
  "objectPath": zod.string(),
  "createdAt": zod.coerce.date()
})
export const ListInvoiceAttachmentsResponse = zod.array(ListInvoiceAttachmentsResponseItem)


/**
 * @summary Save invoice attachment metadata after upload
 */
export const CreateInvoiceAttachmentParams = zod.object({
  "invoiceId": zod.coerce.number()
})

export const CreateInvoiceAttachmentBody = zod.object({
  "fileName": zod.string(),
  "contentType": zod.string(),
  "objectPath": zod.string()
})


/**
 * @summary Delete an invoice attachment (metadata + object from storage)
 */
export const DeleteInvoiceAttachmentParams = zod.object({
  "invoiceId": zod.coerce.number(),
  "attachmentId": zod.coerce.number()
})


/**
 * @summary Convert an accepted estimate to an invoice
 */
export const ConvertEstimateToInvoiceParams = zod.object({
  "id": zod.coerce.number()
})


/**
 * @summary Duplicate an estimate
 */
export const DuplicateEstimateParams = zod.object({
  "id": zod.coerce.number()
})


/**
 * @summary List all invoices
 */
export const ListInvoicesQueryParams = zod.object({
  "status": zod.enum(['draft', 'sent', 'partial', 'paid', 'overdue', 'void']).optional(),
  "customerId": zod.coerce.number().optional(),
  "search": zod.coerce.string().optional(),
  "startDate": zod.coerce.string().optional(),
  "endDate": zod.coerce.string().optional()
})

export const ListInvoicesResponseItem = zod.object({
  "id": zod.coerce.number(),
  "invoiceNumber": zod.string().nullish(),
  "title": zod.string(),
  "status": zod.enum(['draft', 'sent', 'partial', 'paid', 'overdue', 'void']),
  "customerId": zod.coerce.number(),
  "customerName": zod.string().optional(),
  "customerPhone": zod.string().nullish(),
  "customerEmail": zod.string().nullish(),
  "total": zod.coerce.number(),
  "subtotal": zod.coerce.number().optional(),
  "taxAmount": zod.coerce.number().optional(),
  "paidAmount": zod.coerce.number().optional().describe('Sum of all payment records on this invoice. Excludes deposit-source rollups on the parent to avoid double-counting payments collected on a deposit child.'),
  "internalCost": zod.coerce.number().optional(),
  "profit": zod.coerce.number().optional(),
  "margin": zod.coerce.number().optional(),
  "description": zod.string().nullish(),
  "invoiceDate": zod.string().nullish(),
  "dueDate": zod.string().nullish(),
  "depositType": zod.enum(['fixed', 'percent']).optional(),
  "depositValue": zod.coerce.number().optional(),
  "discountType": zod.enum(['fixed', 'percent']).nullish(),
  "discountValue": zod.coerce.number().nullish(),
  "discountAmount": zod.coerce.number().optional(),
  "taxEnabled": zod.boolean().optional(),
  "taxRate": zod.coerce.number().optional(),
  "selectedTaxLines": zod.string().nullish(),
  "linkedEstimateId": zod.coerce.number().nullish(),
  "isRecurring": zod.boolean().optional(),
  "recurringInterval": zod.string().nullish(),
  "recurringCustomDays": zod.coerce.number().nullish(),
  "recurringStartDate": zod.string().nullish(),
  "recurringEndDate": zod.string().nullish(),
  "recurringNextDate": zod.string().nullish(),
  "recurringParentId": zod.coerce.number().nullish(),
  "recurringAutoSend": zod.boolean().optional(),
  "recurringApprovedAt": zod.string().nullish(),
  "overdueReminderEnabled": zod.boolean().optional(),
  "overdueReminderDays": zod.coerce.number().nullish(),
  "lastReminderSentAt": zod.string().nullish(),
  "isDepositChild": zod.boolean().optional(),
  "depositParentId": zod.coerce.number().nullish(),
  "isMilestoneParent": zod.boolean().optional(),
  "milestoneParentId": zod.coerce.number().nullish(),
  "isContainer": zod.boolean().optional(),
  "isBalanceChild": zod.boolean().optional(),
  "stripePaymentLinkUrl": zod.string().nullish(),
  "stripePaymentStatus": zod.string().nullish(),
  "acceptOnlinePayment": zod.boolean().optional(),
  "autoChargeFailedAt": zod.string().nullish(),
  "createdAt": zod.coerce.date(),
  "updatedAt": zod.coerce.date()
})
export const ListInvoicesResponse = zod.array(ListInvoicesResponseItem)


/**
 * @summary Create an invoice
 */
export const CreateInvoiceBody = zod.object({
  "invoiceNumber": zod.string().nullish(),
  "title": zod.string().optional(),
  "customerId": zod.coerce.number(),
  "description": zod.string().optional(),
  "invoiceDate": zod.string().nullish(),
  "dueDate": zod.string().nullish(),
  "depositType": zod.enum(['fixed', 'percent']).optional(),
  "depositValue": zod.coerce.number().optional(),
  "discountType": zod.enum(['fixed', 'percent']).nullish(),
  "discountValue": zod.coerce.number().nullish(),
  "linkedEstimateId": zod.coerce.number().nullish(),
  "isRecurring": zod.boolean().optional(),
  "recurringInterval": zod.string().nullish(),
  "recurringCustomDays": zod.coerce.number().nullish(),
  "recurringStartDate": zod.string().nullish(),
  "recurringEndDate": zod.string().nullish(),
  "recurringAutoSend": zod.boolean().optional(),
  "recurringApprovedAt": zod.string().nullish(),
  "overdueReminderEnabled": zod.boolean().optional(),
  "overdueReminderDays": zod.coerce.number().nullish(),
  "acceptOnlinePayment": zod.boolean().optional()
})


/**
 * @summary Get invoice with all details
 */
export const GetInvoiceParams = zod.object({
  "id": zod.coerce.number()
})

export const GetInvoiceResponse = zod.object({
  "id": zod.coerce.number(),
  "invoiceNumber": zod.string().nullish(),
  "title": zod.string(),
  "status": zod.enum(['draft', 'sent', 'partial', 'paid', 'overdue', 'void']),
  "customerId": zod.coerce.number(),
  "customerName": zod.string().optional(),
  "customerPhone": zod.string().nullish(),
  "customerEmail": zod.string().nullish(),
  "customerAddressLine1": zod.string().nullish(),
  "customerAddressLine2": zod.string().nullish(),
  "customerCity": zod.string().nullish(),
  "customerState": zod.string().nullish(),
  "customerPostalCode": zod.string().nullish(),
  "customerCountry": zod.string().nullish(),
  "isDepositChild": zod.boolean().optional(),
  "depositParentId": zod.coerce.number().nullish(),
  "depositChildId": zod.coerce.number().nullish(),
  "depositChildStatus": zod.string().nullish(),
  "depositChildPaidDate": zod.string().nullish(),
  "depositChildAmount": zod.coerce.number().nullish(),
  "isMilestoneParent": zod.boolean().optional(),
  "milestoneParentId": zod.coerce.number().nullish(),
  "isContainer": zod.boolean().optional(),
  "isBalanceChild": zod.boolean().optional(),
  "balanceChildId": zod.coerce.number().nullish(),
  "balanceChildStatus": zod.string().nullish(),
  "balanceChildPaidDate": zod.string().nullish(),
  "balanceChildAmount": zod.coerce.number().nullish(),
  "total": zod.coerce.number(),
  "subtotal": zod.coerce.number().optional(),
  "taxAmount": zod.coerce.number().optional(),
  "paidAmount": zod.coerce.number().optional().describe('Sum of all payment records on this invoice. Excludes deposit-source rollups on the parent to avoid double-counting payments collected on a deposit child.'),
  "internalCost": zod.coerce.number().optional(),
  "profit": zod.coerce.number().optional(),
  "margin": zod.coerce.number().optional(),
  "description": zod.string().nullish(),
  "termsAndNotes": zod.string().nullish(),
  "invoiceDate": zod.string().nullish(),
  "dueDate": zod.string().nullish(),
  "depositType": zod.enum(['fixed', 'percent']).optional(),
  "depositValue": zod.coerce.number().optional(),
  "discountType": zod.enum(['fixed', 'percent']).nullish(),
  "discountValue": zod.coerce.number().nullish(),
  "discountAmount": zod.coerce.number().optional(),
  "taxEnabled": zod.boolean().optional(),
  "taxRate": zod.coerce.number().optional(),
  "selectedTaxLines": zod.string().nullish(),
  "linkedEstimateId": zod.coerce.number().nullish(),
  "isRecurring": zod.boolean().optional(),
  "recurringInterval": zod.string().nullish(),
  "recurringCustomDays": zod.coerce.number().nullish(),
  "recurringStartDate": zod.string().nullish(),
  "recurringEndDate": zod.string().nullish(),
  "recurringNextDate": zod.string().nullish(),
  "recurringParentId": zod.coerce.number().nullish(),
  "recurringAutoSend": zod.boolean().optional(),
  "recurringApprovedAt": zod.string().nullish(),
  "overdueReminderEnabled": zod.boolean().optional(),
  "overdueReminderDays": zod.coerce.number().nullish(),
  "lastReminderSentAt": zod.string().nullish(),
  "stripePaymentLinkUrl": zod.string().nullish(),
  "stripePaymentStatus": zod.string().nullish(),
  "acceptOnlinePayment": zod.boolean().optional(),
  "autoChargeFailedAt": zod.string().nullish(),
  "lineItems": zod.array(zod.object({
  "id": zod.coerce.number(),
  "invoiceId": zod.coerce.number(),
  "productId": zod.coerce.number().nullish(),
  "groupId": zod.coerce.number().nullish(),
  "description": zod.string(),
  "quantity": zod.coerce.number(),
  "unitPrice": zod.coerce.number(),
  "total": zod.coerce.number(),
  "sortOrder": zod.coerce.number().optional(),
  "privateNote": zod.string().nullish(),
  "internalCostTotal": zod.coerce.number().optional(),
  "productName": zod.string().nullish()
})),
  "groups": zod.array(zod.object({
  "id": zod.coerce.number(),
  "invoiceId": zod.coerce.number(),
  "name": zod.string(),
  "sortOrder": zod.coerce.number(),
  "collapsedByDefault": zod.coerce.number(),
  "accentColor": zod.string().nullish()
})),
  "createdAt": zod.coerce.date(),
  "updatedAt": zod.coerce.date()
})


/**
 * @summary Update an invoice
 */
export const UpdateInvoiceParams = zod.object({
  "id": zod.coerce.number()
})

export const UpdateInvoiceBody = zod.object({
  "invoiceNumber": zod.string().nullish(),
  "title": zod.string().optional(),
  "status": zod.enum(['draft', 'sent', 'partial', 'paid', 'overdue', 'void']).optional(),
  "customerId": zod.coerce.number().optional(),
  "description": zod.string().optional(),
  "invoiceDate": zod.string().nullish(),
  "dueDate": zod.string().nullish(),
  "depositType": zod.enum(['fixed', 'percent']).optional(),
  "depositValue": zod.coerce.number().optional(),
  "discountType": zod.enum(['fixed', 'percent']).nullish(),
  "discountValue": zod.coerce.number().nullish(),
  "taxEnabled": zod.boolean().optional(),
  "taxRate": zod.coerce.number().optional(),
  "selectedTaxLines": zod.string().nullish(),
  "isRecurring": zod.boolean().optional(),
  "recurringInterval": zod.string().nullish(),
  "recurringCustomDays": zod.coerce.number().nullish(),
  "recurringStartDate": zod.string().nullish(),
  "recurringEndDate": zod.string().nullish(),
  "recurringAutoSend": zod.boolean().optional(),
  "recurringApprovedAt": zod.string().nullish(),
  "overdueReminderEnabled": zod.boolean().optional(),
  "overdueReminderDays": zod.coerce.number().nullish(),
  "acceptOnlinePayment": zod.boolean().optional(),
  "termsAndNotes": zod.string().nullish()
})

export const UpdateInvoiceResponse = zod.object({
  "id": zod.coerce.number(),
  "invoiceNumber": zod.string().nullish(),
  "title": zod.string(),
  "status": zod.enum(['draft', 'sent', 'partial', 'paid', 'overdue', 'void']),
  "customerId": zod.coerce.number(),
  "customerName": zod.string().optional(),
  "customerPhone": zod.string().nullish(),
  "customerEmail": zod.string().nullish(),
  "total": zod.coerce.number(),
  "subtotal": zod.coerce.number().optional(),
  "taxAmount": zod.coerce.number().optional(),
  "paidAmount": zod.coerce.number().optional().describe('Sum of all payment records on this invoice. Excludes deposit-source rollups on the parent to avoid double-counting payments collected on a deposit child.'),
  "internalCost": zod.coerce.number().optional(),
  "profit": zod.coerce.number().optional(),
  "margin": zod.coerce.number().optional(),
  "description": zod.string().nullish(),
  "invoiceDate": zod.string().nullish(),
  "dueDate": zod.string().nullish(),
  "depositType": zod.enum(['fixed', 'percent']).optional(),
  "depositValue": zod.coerce.number().optional(),
  "discountType": zod.enum(['fixed', 'percent']).nullish(),
  "discountValue": zod.coerce.number().nullish(),
  "discountAmount": zod.coerce.number().optional(),
  "taxEnabled": zod.boolean().optional(),
  "taxRate": zod.coerce.number().optional(),
  "selectedTaxLines": zod.string().nullish(),
  "linkedEstimateId": zod.coerce.number().nullish(),
  "isRecurring": zod.boolean().optional(),
  "recurringInterval": zod.string().nullish(),
  "recurringCustomDays": zod.coerce.number().nullish(),
  "recurringStartDate": zod.string().nullish(),
  "recurringEndDate": zod.string().nullish(),
  "recurringNextDate": zod.string().nullish(),
  "recurringParentId": zod.coerce.number().nullish(),
  "recurringAutoSend": zod.boolean().optional(),
  "recurringApprovedAt": zod.string().nullish(),
  "overdueReminderEnabled": zod.boolean().optional(),
  "overdueReminderDays": zod.coerce.number().nullish(),
  "lastReminderSentAt": zod.string().nullish(),
  "isDepositChild": zod.boolean().optional(),
  "depositParentId": zod.coerce.number().nullish(),
  "isMilestoneParent": zod.boolean().optional(),
  "milestoneParentId": zod.coerce.number().nullish(),
  "isContainer": zod.boolean().optional(),
  "isBalanceChild": zod.boolean().optional(),
  "stripePaymentLinkUrl": zod.string().nullish(),
  "stripePaymentStatus": zod.string().nullish(),
  "acceptOnlinePayment": zod.boolean().optional(),
  "autoChargeFailedAt": zod.string().nullish(),
  "createdAt": zod.coerce.date(),
  "updatedAt": zod.coerce.date()
})


/**
 * @summary Delete an invoice
 */
export const DeleteInvoiceParams = zod.object({
  "id": zod.coerce.number()
})


/**
 * @summary Mark deposit as received (creates child invoice + payment in one step)
 */
export const MarkDepositReceivedParams = zod.object({
  "id": zod.coerce.number()
})

export const MarkDepositReceivedBody = zod.object({
  "amount": zod.coerce.number(),
  "paymentMethod": zod.string().nullish(),
  "paymentDate": zod.string().optional(),
  "notes": zod.string().nullish()
})


/**
 * @summary Duplicate an invoice
 */
export const DuplicateInvoiceParams = zod.object({
  "id": zod.coerce.number()
})


/**
 * @summary List line items for an invoice
 */
export const ListInvoiceLineItemsParams = zod.object({
  "invoiceId": zod.coerce.number()
})

export const ListInvoiceLineItemsResponseItem = zod.object({
  "id": zod.coerce.number(),
  "invoiceId": zod.coerce.number(),
  "productId": zod.coerce.number().nullish(),
  "groupId": zod.coerce.number().nullish(),
  "description": zod.string(),
  "quantity": zod.coerce.number(),
  "unitPrice": zod.coerce.number(),
  "total": zod.coerce.number(),
  "sortOrder": zod.coerce.number().optional(),
  "privateNote": zod.string().nullish(),
  "internalCostTotal": zod.coerce.number().optional(),
  "productName": zod.string().nullish()
})
export const ListInvoiceLineItemsResponse = zod.array(ListInvoiceLineItemsResponseItem)


/**
 * @summary Add a line item to an invoice
 */
export const CreateInvoiceLineItemParams = zod.object({
  "invoiceId": zod.coerce.number()
})

export const CreateInvoiceLineItemBody = zod.object({
  "productId": zod.coerce.number().nullish(),
  "groupId": zod.coerce.number().nullish(),
  "description": zod.string(),
  "quantity": zod.coerce.number(),
  "unitPrice": zod.coerce.number(),
  "sortOrder": zod.coerce.number().optional(),
  "privateNote": zod.string().nullish()
})


/**
 * @summary Update an invoice line item
 */
export const UpdateInvoiceLineItemParams = zod.object({
  "invoiceId": zod.coerce.number(),
  "id": zod.coerce.number()
})

export const UpdateInvoiceLineItemBody = zod.object({
  "productId": zod.coerce.number().nullish(),
  "groupId": zod.coerce.number().nullish(),
  "description": zod.string(),
  "quantity": zod.coerce.number(),
  "unitPrice": zod.coerce.number(),
  "sortOrder": zod.coerce.number().optional(),
  "privateNote": zod.string().nullish()
})

export const UpdateInvoiceLineItemResponse = zod.object({
  "id": zod.coerce.number(),
  "invoiceId": zod.coerce.number(),
  "productId": zod.coerce.number().nullish(),
  "groupId": zod.coerce.number().nullish(),
  "description": zod.string(),
  "quantity": zod.coerce.number(),
  "unitPrice": zod.coerce.number(),
  "total": zod.coerce.number(),
  "sortOrder": zod.coerce.number().optional(),
  "privateNote": zod.string().nullish(),
  "internalCostTotal": zod.coerce.number().optional(),
  "productName": zod.string().nullish()
})


/**
 * @summary Delete an invoice line item
 */
export const DeleteInvoiceLineItemParams = zod.object({
  "invoiceId": zod.coerce.number(),
  "id": zod.coerce.number()
})


/**
 * @summary Set or clear private note on an invoice line item
 */
export const UpdateInvoiceLineItemNoteParams = zod.object({
  "invoiceId": zod.coerce.number(),
  "lineItemId": zod.coerce.number()
})

export const UpdateInvoiceLineItemNoteBody = zod.object({
  "privateNote": zod.string().nullish()
})

export const UpdateInvoiceLineItemNoteResponse = zod.object({
  "id": zod.coerce.number(),
  "invoiceId": zod.coerce.number(),
  "productId": zod.coerce.number().nullish(),
  "groupId": zod.coerce.number().nullish(),
  "description": zod.string(),
  "quantity": zod.coerce.number(),
  "unitPrice": zod.coerce.number(),
  "total": zod.coerce.number(),
  "sortOrder": zod.coerce.number().optional(),
  "privateNote": zod.string().nullish(),
  "internalCostTotal": zod.coerce.number().optional(),
  "productName": zod.string().nullish()
})


/**
 * @summary List line item groups for an invoice
 */
export const ListInvoiceLineItemGroupsParams = zod.object({
  "invoiceId": zod.coerce.number()
})

export const ListInvoiceLineItemGroupsResponseItem = zod.object({
  "id": zod.coerce.number(),
  "invoiceId": zod.coerce.number(),
  "name": zod.string(),
  "sortOrder": zod.coerce.number(),
  "collapsedByDefault": zod.coerce.number(),
  "accentColor": zod.string().nullish()
})
export const ListInvoiceLineItemGroupsResponse = zod.array(ListInvoiceLineItemGroupsResponseItem)


/**
 * @summary Create a new invoice line item group
 */
export const CreateInvoiceLineItemGroupParams = zod.object({
  "invoiceId": zod.coerce.number()
})

export const CreateInvoiceLineItemGroupBody = zod.object({
  "name": zod.string(),
  "sortOrder": zod.coerce.number().optional(),
  "collapsedByDefault": zod.coerce.number().optional(),
  "accentColor": zod.string().nullish()
})


/**
 * @summary Update an invoice line item group
 */
export const UpdateInvoiceLineItemGroupParams = zod.object({
  "invoiceId": zod.coerce.number(),
  "id": zod.coerce.number()
})

export const UpdateInvoiceLineItemGroupBody = zod.object({
  "name": zod.string().optional(),
  "sortOrder": zod.coerce.number().optional(),
  "collapsedByDefault": zod.coerce.number().optional(),
  "accentColor": zod.string().nullish()
})

export const UpdateInvoiceLineItemGroupResponse = zod.object({
  "id": zod.coerce.number(),
  "invoiceId": zod.coerce.number(),
  "name": zod.string(),
  "sortOrder": zod.coerce.number(),
  "collapsedByDefault": zod.coerce.number(),
  "accentColor": zod.string().nullish()
})


/**
 * @summary Delete an invoice line item group (ungrouping its items)
 */
export const DeleteInvoiceLineItemGroupParams = zod.object({
  "invoiceId": zod.coerce.number(),
  "id": zod.coerce.number()
})


/**
 * @summary List internal costs for an invoice line item
 */
export const ListInvoiceCostsParams = zod.object({
  "invoiceId": zod.coerce.number(),
  "lineItemId": zod.coerce.number()
})

export const ListInvoiceCostsResponseItem = zod.object({
  "id": zod.coerce.number(),
  "lineItemId": zod.coerce.number(),
  "catalogItemId": zod.coerce.number().nullish(),
  "name": zod.string(),
  "quantity": zod.coerce.number(),
  "unit": zod.string().nullish(),
  "unitCost": zod.coerce.number(),
  "totalCost": zod.coerce.number(),
  "supplier": zod.string().nullish(),
  "notes": zod.string().nullish(),
  "type": zod.enum(['labour', 'materials', 'fees']),
  "fromProductDefaultId": zod.coerce.number().nullish()
})
export const ListInvoiceCostsResponse = zod.array(ListInvoiceCostsResponseItem)


/**
 * @summary Add an internal cost to an invoice line item
 */
export const CreateInvoiceCostParams = zod.object({
  "invoiceId": zod.coerce.number(),
  "lineItemId": zod.coerce.number()
})

export const CreateInvoiceCostBody = zod.object({
  "catalogItemId": zod.coerce.number().nullish(),
  "name": zod.string(),
  "quantity": zod.coerce.number(),
  "unit": zod.string().nullish(),
  "unitCost": zod.coerce.number(),
  "supplier": zod.string().nullish(),
  "notes": zod.string().nullish(),
  "type": zod.enum(['labour', 'materials', 'fees']).optional(),
  "category": zod.string().nullish()
})


/**
 * @summary Update an internal cost for an invoice line item
 */
export const UpdateInvoiceCostParams = zod.object({
  "invoiceId": zod.coerce.number(),
  "lineItemId": zod.coerce.number(),
  "id": zod.coerce.number()
})

export const UpdateInvoiceCostBody = zod.object({
  "catalogItemId": zod.coerce.number().nullish(),
  "name": zod.string(),
  "quantity": zod.coerce.number(),
  "unit": zod.string().nullish(),
  "unitCost": zod.coerce.number(),
  "supplier": zod.string().nullish(),
  "notes": zod.string().nullish(),
  "type": zod.enum(['labour', 'materials', 'fees']).optional(),
  "category": zod.string().nullish()
})

export const UpdateInvoiceCostResponse = zod.object({
  "id": zod.coerce.number(),
  "lineItemId": zod.coerce.number(),
  "catalogItemId": zod.coerce.number().nullish(),
  "name": zod.string(),
  "quantity": zod.coerce.number(),
  "unit": zod.string().nullish(),
  "unitCost": zod.coerce.number(),
  "totalCost": zod.coerce.number(),
  "supplier": zod.string().nullish(),
  "notes": zod.string().nullish(),
  "type": zod.enum(['labour', 'materials', 'fees']),
  "fromProductDefaultId": zod.coerce.number().nullish()
})


/**
 * @summary Delete an internal cost for an invoice line item
 */
export const DeleteInvoiceCostParams = zod.object({
  "invoiceId": zod.coerce.number(),
  "lineItemId": zod.coerce.number(),
  "id": zod.coerce.number()
})


/**
 * @summary Get invoice dashboard summary stats
 */
export const GetInvoiceDashboardSummaryQueryParams = zod.object({
  "startDate": zod.coerce.string().optional(),
  "endDate": zod.coerce.string().optional()
})

export const GetInvoiceDashboardSummaryResponse = zod.object({
  "totalInvoices": zod.coerce.number(),
  "totalInvoiced": zod.coerce.number(),
  "totalPaid": zod.coerce.number(),
  "totalOutstanding": zod.coerce.number(),
  "totalOverdue": zod.coerce.number()
})


/**
 * @summary Get invoice revenue broken down by product category
 */
export const GetInvoiceDashboardRevenueByCategoryQueryParams = zod.object({
  "startDate": zod.coerce.string().optional(),
  "endDate": zod.coerce.string().optional()
})

export const GetInvoiceDashboardRevenueByCategoryResponseItem = zod.object({
  "category": zod.string(),
  "total": zod.coerce.number()
})
export const GetInvoiceDashboardRevenueByCategoryResponse = zod.array(GetInvoiceDashboardRevenueByCategoryResponseItem)


